(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["positive-pen-editorial"] && !Shopify.designMode) return;
  try {
    
function prepareHomeSidebar(root) {
  const panel = root.querySelector('.pp-home-layout .pp-browse-panel');
  if (!panel || panel.dataset.homeReady) return;
  if (window.matchMedia('(max-width: 749px)').matches) panel.removeAttribute('open');
  panel.dataset.homeReady = 'true';
}
function rotateHomepageFeatures(root) {
  root.querySelectorAll('[data-home-rotation]').forEach(group => {
    if (group.dataset.ready) return;
    const grid = group.querySelector('[data-home-cards]');
    const pool = group.querySelector('template[data-home-pool]');
    if (!grid || !pool) return;
    const cards = Array.from(pool.content.children);
    const count = Math.min(3, cards.length);
    if (!count) return;
    const cardId = card => card.dataset.homeWriter || card.dataset.libraryId;
    const key = 'positive-pen:home:' + group.dataset.homeRotation;
    let previous = [];
    try { const saved = JSON.parse(sessionStorage.getItem(key) || '[]'); if (Array.isArray(saved)) previous = saved; } catch {}
    let candidates = cards.filter(card => !previous.includes(cardId(card)));
    if (candidates.length < count) candidates = cards.slice();
    for (let i = candidates.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [candidates[i], candidates[j]] = [candidates[j], candidates[i]];
    }
    const selected = candidates.slice(0, count);
    grid.replaceChildren(...selected.map(card => card.cloneNode(true)));
    group.dataset.ready = 'true';
    try { sessionStorage.setItem(key, JSON.stringify(selected.map(cardId))); } catch {}
  });
}
prepareHomeSidebar(document);
rotateHomepageFeatures(document);
document.addEventListener('shopify:section:load', event => {
  prepareHomeSidebar(event.target);
  rotateHomepageFeatures(event.target);
});

function initializePenHero(root) {
  root.querySelectorAll('.pp-home .pp-hero-image').forEach(hero => {
    if (hero.dataset.rotationReady) return;
    const slides = Array.from(hero.querySelectorAll(':scope > img'));
    const dots = hero.querySelector('[data-hero-dots]');
    const toggle = hero.querySelector('[data-hero-toggle]');
    if (slides.length < 2 || !dots || !toggle) return;
    hero.dataset.rotationReady = 'true';
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0;
    let timer;
    let paused = reduced.matches;
    const stop = () => { clearInterval(timer); timer = undefined; };
    const show = next => {
      index = next;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      Array.from(dots.children).forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
    };
    const updateToggle = () => {
      toggle.textContent = paused ? '▶' : 'Ⅱ';
      toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
    };
    const start = () => {
      stop();
      if (!paused && !reduced.matches && !document.hidden && !hero.matches(':hover') && !hero.contains(document.activeElement)) timer = setInterval(() => show((index + 1) % slides.length), 6000);
    };
    slides.forEach((slide, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', slide.alt);
      dot.addEventListener('click', () => { show(i); paused = true; updateToggle(); stop(); });
      dots.append(dot);
    });
    toggle.addEventListener('click', () => { paused = !paused; updateToggle(); start(); });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', () => setTimeout(start, 0));
    document.addEventListener('visibilitychange', start);
    reduced.addEventListener('change', () => { if (reduced.matches) paused = true; updateToggle(); start(); });
    show(0);
    updateToggle();
    start();
  });
}
initializePenHero(document);
document.addEventListener('shopify:section:load', event => initializePenHero(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["positive-pen-library"] && !Shopify.designMode) return;
  try {
    
function rotatePenLibraryFeatures(root) {
  root.querySelectorAll('[data-library-rotation]').forEach(group => {
    if (group.dataset.rotationReady) return;
    const grid = group.querySelector('[data-rotation-cards]');
    const template = group.querySelector('template[data-rotation-pool]');
    if (!grid || !template) return;
    const cards = Array.from(template.content.querySelectorAll('[data-library-entry]'));
    if (!cards.length) return;
    const count = Math.min(3, cards.length);
    const storageKey = `positive-pen-library:${location.pathname}:${group.dataset.libraryRotation}`;
    let previous = [];
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
      if (Array.isArray(saved)) previous = saved;
    } catch {}
    let candidates = cards.filter(card => !previous.includes(card.dataset.libraryId));
    if (candidates.length < count) candidates = cards.slice();
    for (let i = candidates.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [candidates[i], candidates[j]] = [candidates[j], candidates[i]];
    }
    const selected = candidates.slice(0, count);
    grid.replaceChildren(...selected.map(card => card.cloneNode(true)));
    group.dataset.rotationReady = 'true';
    try {
      sessionStorage.setItem(storageKey, JSON.stringify(selected.map(card => card.dataset.libraryId)));
    } catch {}
  });
}
function initializePenLibrary(root) {
  rotatePenLibraryFeatures(root);
  const input = root.querySelector('#pp-library-search');
  if (!input || input.dataset.ready) return;
  input.dataset.ready = 'true';
  input.addEventListener('input', () => {
    const query = input.value.trim().toLocaleLowerCase();
    const entries = root.querySelectorAll('[data-library-entry]');
    let matches = 0;
    entries.forEach(entry => {
      const visible = entry.dataset.librarySearch.toLocaleLowerCase().includes(query);
      entry.hidden = !visible;
      if (visible) matches++;
    });
    root.querySelector('.pp-library-empty').hidden = !query || matches > 0;
  });
  const panel = root.querySelector('.pp-browse-panel');
  if (panel && window.matchMedia('(max-width: 749px)').matches) panel.open = false;
}
initializePenLibrary(document);
document.addEventListener('shopify:section:load', event => initializePenLibrary(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["positive-pen-screen"] && !Shopify.designMode) return;
  try {
    
function preparePenScreen(root) {
 const page = root.querySelector('.ppsx-page');
 if (!page || page.dataset.ready) return;
 page.dataset.ready = 'true';
 const browse = page.querySelector('.pp-browse-panel');
 if (browse && window.matchMedia('(max-width: 749px)').matches) browse.open = false;
 const video = page.querySelector('#PenShortFilm');
 const button = page.querySelector('[data-short-play]');
 button.addEventListener('click', () => { video.scrollIntoView({behavior:'smooth',block:'center'}); video.play().catch(() => video.focus()); });
}
preparePenScreen(document);
document.addEventListener('shopify:section:load', event => preparePenScreen(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["positive-pen-store"] && !Shopify.designMode) return;
  try {
    
function preparePenStore(root) {
  const store = root.querySelector('.pps-store');
  if (!store) return;
  const browsePanel = store.querySelector('.pp-browse-panel');
  if (browsePanel && window.matchMedia('(max-width: 749px)').matches) {
    browsePanel.open = false;
  }
}
preparePenStore(document);
document.addEventListener('shopify:section:load', event => {
  preparePenStore(event.target);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thankful-stories-review"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.pp-promo-grid').forEach((grid) => {
    const cards = Array.from(grid.children);
    for (let i = cards.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [cards[i], cards[j]] = [cards[j], cards[i]];
    }
    cards.forEach((card) => grid.appendChild(card));
    grid.dispatchEvent(new CustomEvent('pp:promotions-ready',{bubbles:true}));
  });
});

  } catch(e) { console.error(e); }
})();
})();
